'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MastheadExtensionSubscriptionButtons = undefined;

var _themeProvider = require('@spp/theme-provider');

var _MastheadExtensionSubscriptionButtons = require('./MastheadExtensionSubscriptionButtons');

var _MastheadExtensionSubscriptionButtons2 = _interopRequireDefault(_MastheadExtensionSubscriptionButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.MastheadExtensionSubscriptionButtons = _MastheadExtensionSubscriptionButtons2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-masthead-extension-subscription-buttons')(_MastheadExtensionSubscriptionButtons2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MastheadExtensionSubscriptionButtons/index.js
 ** module id = 292
 ** module chunks = 1
 **/